import { theme } from "@huub-web/ui/theme/css/theme.css";
import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";

export const illustrationStyle = recipe({
  variants: {
    size: {
      xxs: {
        width: rem(72),
        height: rem(72),
      },
      xs: {
        width: rem(72),
        height: rem(72),
      },
      s: {
        width: rem(96),
        height: rem(96),
      },
      m: {
        width: rem(96),
        height: rem(96),
      },
      l: {
        width: rem(96),
        height: rem(96),
      },
      auto: {
        width: "auto",
        height: "auto",
      },
    },
  },
  defaultVariants: {
    size: "s",
  },
});

export const whitelabelCardStyle = recipe({
  base: {
    width: "100%",
    height: "100%",
  },
});

export const whitelabelInnerCardStyle = recipe({
  base: {
    background: theme.colors.primary,
    color: theme.colors.onPrimary,
  },
  variants: {
    size: {},
    theme: {
      unive: {},
      deHypotheker: {},
      ing: {},
      rabobank: {},
      quion: {},
      nationaleNederlanden: {},
      vanLanschotKempen: {},
      verenigingEigenHuis: {
        background: "#FFF8F0",
        color: "#EA7405",
      },
      nibc: {},
      munt: {},
      hypotheekvisie: {},
      obvion: {
        background: theme.colors.tertiary,
        color: theme.colors.primary,
      },
      vista: {},
      asr: {},
      anwb: {},
      eviVanLanschot: {},
      allianz: {},
      fnv: {},
      randstad: {},
      achmea: {},
      funda: {},
      nvm: {},
      abnamro: {},
      domek: {},
    },
  },
  defaultVariants: {},
});

export const whitelabelCardContentStyle = recipe({
  base: {
    textAlign: "center",
    alignItems: "center",
    justifyContent: "center",
  },
  variants: {
    size: {
      xxs: {},
      xs: {},
      s: {},
      m: {},
      l: {},
      auto: {},
    },
  },
  defaultVariants: {
    size: "m",
  },
});

export const whitelabelIconStyle = recipe({
  base: {},
  variants: {
    size: {
      xxs: {
        width: rem(28),
        height: rem(28),
      },
      xs: {
        width: rem(28),
        height: rem(28),
      },
      s: {
        width: rem(40),
        height: rem(40),
      },
      m: {
        width: rem(40),
        height: rem(40),
      },
      l: {
        width: rem(40),
        height: rem(40),
      },
      auto: {},
    },
  },
  defaultVariants: {
    size: "m",
  },
});
